
export class SystemProperties {
    public editUiTexts: boolean;
    public hisDevelopmentMode: boolean;
    public languages: string;
    public menuType: string;
    public modules: string;
    public images: Record<string, string> = {};
    public operationMode: string;
    public faces: boolean;
    public htmlEditorEnter: string;
    public htmlEditorShiftEnter: string;
    public contextPath: string;
    public versionHash: string;
}
